import { ProviderViewTextAndTextareaProps } from '../../Context/types'
import Styled from './providerViewTextAndTextarea.module.css'
import HTMLReactParser from 'html-react-parser'
import { LandingContext } from '../../Context'
import { useContext } from 'react'
import { TextArea, LabelText, FormGroup } from '../../Components/Global'

function ProviderViewTextAndTextarea({ valueState, title }: ProviderViewTextAndTextareaProps) {

    const { websiteSettings, setWebsiteSettings } = useContext(LandingContext)

    return (
        <>
            {
                valueState.ToggleView ? (
                    <article className={Styled.viewText}>
                        {HTMLReactParser(valueState.value)}
                    </article>
                )
                    : (
                        <FormGroup className={Styled.formGroup} id="container_area_text">
                            <LabelText htmlFor={title}>{title}</LabelText>
                            <TextArea name={valueState.ref} placeholder="Escreva algo aqui" id={Styled.textarea} value={valueState.value}
                                onChange={e => setWebsiteSettings({
                                    ...websiteSettings, [valueState.ref]: {
                                        ref: valueState.ref,
                                        value: e.target.value,
                                        ToggleView: valueState.ToggleView
                                    }
                                })} />
                        </FormGroup>
                    )
            }
        </>
    )
}

export default ProviderViewTextAndTextarea